import { useLocation } from 'react-router-dom'
import { LogOut, ExternalLink } from 'lucide-react'
import { NAV, isGroup, isLabel } from '../../lib/nav'
import { useAuth } from '../../store/auth'

function titleForPath(pathname: string): string {
  for (const e of NAV) {
    if (isGroup(e)) {
      const hit = e.items.find((i) => i.to === pathname)
      if (hit) return `${e.label} · ${hit.label}`
    } else if (!isLabel(e) && e.to === pathname) {
      return e.label
    }
  }
  return 'Gestionale'
}

export function Topbar() {
  const { pathname } = useLocation()
  const user = useAuth((s) => s.user)
  const logout = useAuth((s) => s.logout)

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-ink-200 bg-white px-5">
      <h1 className="text-[15px] font-semibold text-ink-900">{titleForPath(pathname)}</h1>
      <div className="flex items-center gap-3">
        <a
          href="https://booking.garagesanmarco.it/admin/"
          target="_blank"
          rel="noreferrer"
          className="btn btn-ghost text-2xs"
          title="Apri il gestionale legacy (produzione)"
        >
          <ExternalLink className="h-3.5 w-3.5" /> Legacy
        </a>
        <div className="flex items-center gap-2.5 border-l border-ink-200 pl-3">
          <div className="text-right leading-tight">
            <p className="text-[13px] font-semibold text-ink-800">{user?.name ?? '—'}</p>
            <p className="text-2xs text-ink-400">{user?.email}</p>
          </div>
          <span className="flex h-8 w-8 items-center justify-center rounded bg-ink-900 text-xs font-bold text-white">
            {(user?.name ?? 'G').slice(0, 1).toUpperCase()}
          </span>
          <button onClick={() => logout()} className="btn btn-ghost" title="Esci">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  )
}
